module.exports = __webpack_public_path__ + "static/media/uit.fc408381.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/uit.jpg
// module id = 5805
// module chunks = 0